import { render, staticRenderFns } from "./MarkdownView.vue?vue&type=template&id=b32a2b9a&scoped=true&"
import script from "./MarkdownView.vue?vue&type=script&lang=js&"
export * from "./MarkdownView.vue?vue&type=script&lang=js&"
import style0 from "./MarkdownView.vue?vue&type=style&index=0&id=b32a2b9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32a2b9a",
  null
  
)

export default component.exports